import { render, staticRenderFns } from "./PlasiyerTahsilatAnaliz.vue?vue&type=template&id=09cf373e&scoped=true"
import script from "./PlasiyerTahsilatAnaliz.vue?vue&type=script&lang=js"
export * from "./PlasiyerTahsilatAnaliz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cf373e",
  null
  
)

export default component.exports